<script>
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import Select from "../../components/Select.svelte";
	import CheckboxButton from "../../components/CheckboxButton.svelte";

	export let responsibilityType = null;
	export let responsibility;
	export let responsibilityHours = null;
	export let disabled = null;
	export let required = null;

	const hoursOptions = [
		{ label: "1 hours", value: 1 },
		{ label: "2 hours", value: 2 },
		{ label: "3 hours", value: 3 },
		{ label: "4 hours", value: 4 },
		{ label: "5 hours", value: 5 },
		{ label: "6 hours", value: 6 },
		{ label: "7 hours", value: 7 },
		{ label: "8 hours", value: 8 },
		{ label: "9 hours", value: 9 },
		{ label: "10 hours", value: 10 },
		{ label: "11 hours", value: 11 },
		{ label: "12 hours", value: 12 },
		{ label: "13 hours", value: 13 },
		{ label: "14 hours", value: 14 },
		{ label: "15 hours", value: 15 },
		{ label: "16 hours", value: 16 },
		{ label: "17 hours", value: 17 },
		{ label: "18 hours", value: 18 },
		{ label: "19 hours", value: 19 },
		{ label: "20 hours", value: 20 },
		{ label: "21 hours", value: 21 },
		{ label: "22 hours", value: 22 },
		{ label: "23 hours", value: 23 },
		{ label: "24 hours", value: 24 },
		{ label: "25 hours", value: 25 },
		{ label: "26 hours", value: 26 },
		{ label: "27 hours", value: 27 },
		{ label: "28 hours", value: 28 },
		{ label: "29 hours", value: 29 },
		{ label: "30 hours", value: 30 },
		{ label: "More than 30 hours", value: 31 }
	];
</script>

<FormRow>
	<FormColumn>
		<CheckboxButton
			{disabled}
			id={responsibilityType.replace(" ", "_")}
			label={responsibilityType}
			bind:checked={responsibility} />
	</FormColumn>
</FormRow>

{#if responsibility}
	<FormRow>
		<FormColumn>
			<Select
				{required}
				{disabled}
				label="Generally, how many hours per week were you undertaking this additional responsibility (approximately)"
				id="{responsibilityType.replace(' ', '_')}_hours"
				bind:value={responsibilityHours}
				optionList={hoursOptions}
				textProperty="label"
				valueProperty="value" />
		</FormColumn>
	</FormRow>
{/if}
